<template>
  <div>
    <template v-if="isMobile">
        <br> 
        <div data-aos="flip-left" data-aos-delay="250"     data-aos-duration="600"> 
          <img :src="'ranking/' + rankin_sub + '_movil.png'" class="rounded mt-5" alt="Image"    style="width:100%;" >
        </div>
        </template>
    <template v-else>
        <br><br> 
        <div data-aos="flip-left" data-aos-delay="250"     data-aos-duration="600"> 
           <img :src="'ranking/' + rankin_sub + '.png'" class="rounded mt-5" alt="Image"    style="width:55%;" >
        </div>
        <br><br>
    </template>  
  </div>
</template>

<script>
export default {
  name: 'img', 
  props:["rankin_sub"],
  data(){
     return{ 
         isMobile: this.$mobile(),
     }
  },
 computed: {
    user() {
      return this.$store.getters.getInfoUser;
    }
  },  
  mounted(){ 
     window.AOS.init({
      // offset: 20,
      duration: 500,
      easing: 'ease-in-sine',
      delay: 300,
      anchorPlacement:'top-bottom', 
    });  
  }
}
</script>